// Activar el input de teléfono
var input = document.querySelector("#phone");
if (input) {
    window.intlTelInput(input, {
        separateDialCode: true,
        initialCountry: "ES",
        countryCode: 'es',
    });
}

// Abrir popups
document.querySelectorAll(".click-to-open-popup").forEach(function (el) {
    el.addEventListener("click", function () {
        var popup = el.dataset.popup;
        var target = document.querySelector("." + popup);
        if (target) target.classList.add("active");
    });
});

// Cerrar popups
document.querySelectorAll(".close-popup").forEach(function (el) {
    el.addEventListener("click", function () {
        var popupContainer = el.closest(".container-popup-product");
        if (popupContainer) popupContainer.classList.remove("active");
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const wishlistButtons = document.querySelectorAll(".btn-wishlist");

    wishlistButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            const productId = this.getAttribute("data-product-id");

            // Lógica para agregar el producto a la lista de deseos usando la API de Wishify
            // Este es un ejemplo genérico; consulta la documentación de Wishify para detalles específicos
            Wishify.addToWishlist(productId);
        });
    });


    // =======================
    // Judge.me: mover widget + título + rating resumen
    // =======================
    let JDGM_MOVED = false;           // ¿ya movimos el widget?
    let JDGM_TITLE_APPLIED = false;   // ¿ya aplicamos el título e íconos?
    let obs = null;

    // Debounce utilitario
    const debounce = (fn, wait = 120) => {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    };

    // --------- Helpers para rating (.product-rating) ---------
    function getAverageFromJudgeMe() {
        // 1) Intento principal: el span de Judge.me
        const el = document.querySelector('.jdgm-rev-widg__summary-average');
        if (el) {
            // textContent puede traer: "4.00 out of 5", "4,00 de 5", "4.0/5", etc.
            // Normalizamos NBSP y espacios raros
            let txt = (el.textContent || '').replace(/\u00A0/g, ' ').trim();

            // Acepta punto o coma, y varios formatos ("out of 5" / "de 5" / "/5" / solo número)
            // Capturamos el primer número decimal razonable
            let m = txt.match(/([0-9]+(?:[.,][0-9]+)?)(?=\s*(?:out\s*of|de|\/)?\s*5\b|[^\d]|$)/i)
                || txt.match(/([0-9]+(?:[.,][0-9]+)?)/);

            if (m && m[1]) {
                const rawCaptured = m[1];                // lo que queremos mostrar
                const num = Number(rawCaptured.replace(',', '.')); // convertir a número aunque use coma
                if (!Number.isNaN(num)) {
                    // rawDisplay: preserva el formato “como viene”, pero si quieres forzar 2 decimales:
                    // const rawDisplay = (Math.round(num * 100) / 100).toFixed(2);
                    const rawDisplay = rawCaptured;
                    return { raw: rawDisplay, num };
                }
            }
        }

        // 2) Fallback por atributos comunes (por si tu tema/versión de Judge.me los expone)
        const attrEl =
            document.querySelector('[data-average]') ||
            document.querySelector('[data-average-rating]') ||
            document.querySelector('.jdgm-rev-widg__summary[data-average]') ||
            document.querySelector('.jdgm-rev-widg__summary[data-average-rating]');

        if (attrEl) {
            const v =
                attrEl.getAttribute('data-average') ||
                attrEl.getAttribute('data-average-rating');

            if (v) {
                const num = Number(String(v).replace(',', '.'));
                if (!Number.isNaN(num)) {
                    // Preserva 2 decimales para mostrar algo consistente
                    return { raw: (Math.round(num * 100) / 100).toFixed(2), num };
                }
            }
        }

        // 3) Último fallback: buscar un número con pinta de rating cerca del summary
        const summary = document.querySelector('.jdgm-rev-widg__summary') || el?.closest('.jdgm-rev-widg');
        if (summary) {
            const txt = summary.textContent.replace(/\u00A0/g, ' ').trim();
            const m = txt.match(/([0-9]+(?:[.,][0-9]+)?)\s*(?:out\s*of|de|\/)?\s*5/i)
                || txt.match(/([0-9]+(?:[.,][0-9]+)?)/);
            if (m && m[1]) {
                const rawCaptured = m[1];
                const num = Number(rawCaptured.replace(',', '.'));
                if (!Number.isNaN(num)) {
                    return { raw: rawCaptured, num };
                }
            }
        }

        // Si llegamos aquí, no pudimos extraerlo
        return null;
    }


    function getCountFromJudgeMe() {
        // Cubre "Based on 2 reviews" y variantes
        const countEl = document.querySelector('.jdgm-rev-widg__summary-text');
        if (!countEl) return null;
        const txt = (countEl.textContent || '').trim();
        const m = txt.match(/Based on\s+(\d+)\s+reviews?/i) || txt.match(/(\d+)\s+reviews?/i);
        if (!m) return null;
        const num = parseInt(m[1], 10);
        if (!Number.isFinite(num)) return null;
        return num;
    }

    function updateProductRating() {
        const container = document.querySelector('.product-rating');
        if (!container) return;

        const avg = getAverageFromJudgeMe();
        const count = getCountFromJudgeMe();

        console.debug('Judge.me rating:', { avg, count });
        // Si falta cualquiera de los dos -> conserva lo que pintó el servidor
        if (!avg || !Number.isFinite(count)) {
            // Mantener el valor renderizado en servidor (metafield Judge.me). No eliminar.
            return;
        }

        const scoreEl = container.querySelector('.rating-score');
        const countEl = container.querySelector('.rating-count');
        const starsEl = container.querySelector('.rating-stars');

        const scoreText = avg.num.toFixed(1);  // 1 decimal (ej. 5.0), igual que el servidor
        if (scoreEl) scoreEl.textContent = scoreText;
        if (countEl) countEl.textContent = `(${count})`;

        const titleText = `${scoreText} / 5 basado en ${count} reseña${count === 1 ? '' : 's'}`;
        container.title = titleText;
        if (starsEl && !starsEl.getAttribute('aria-label')) {
            starsEl.setAttribute('aria-label', titleText);
        }
    }

    // --------- Cambiar título del widget + limpiar íconos ---------
    function setReviewsTitle() {
        if (JDGM_TITLE_APPLIED) return;

        const widget = document.getElementById('judgeme_product_reviews');
        if (!widget) return;

        const titleEl = widget.querySelector('.jdgm-rev-widg__title');
        if (titleEl && titleEl.textContent.trim() !== 'Reviews') {
            titleEl.textContent = 'Reviews';
        }

        // Quitar iconos con o sin jQuery
        if (window.jQuery) {
            const $ = window.jQuery;
            $('.jdgm-rev__icon').remove();
        } else {
            document.querySelectorAll('.jdgm-rev__icon').forEach(n => n.remove());
        }

        JDGM_TITLE_APPLIED = !!titleEl;

        // Revalidación ligera
        setTimeout(() => {
            const t2 = widget.querySelector('.jdgm-rev-widg__title');
            if (t2 && t2.textContent.trim() !== 'Reviews') {
                JDGM_TITLE_APPLIED = false;
                setReviewsTitle();
            }
        }, 200);
    }

    // --------- Mover widget a #reviews-target y refrescar ---------
    function moveJudgeMe() {
        if (JDGM_MOVED) return;

        const widget = document.getElementById('judgeme_product_reviews');

        const target = document.getElementById('reviews-target');
        if (widget && target && !target.contains(widget)) {
            JDGM_MOVED = true;

            // Evita que el propio movimiento dispare el observer
            if (obs) obs.disconnect();

            target.appendChild(widget);

            // Tras el movimiento, refresca y aplica título y rating
            requestAnimationFrame(() => {
                window.dispatchEvent(new Event('jdgm:refresh'));
                setTimeout(() => {
                    setReviewsTitle();
                    updateProductRating();
                }, 60);
            });
        }
    }

    // --------- Inicializaciones ---------
    moveJudgeMe();
    setTimeout(() => {
        setReviewsTitle();
        updateProductRating();
    }, 60);

    // Observer: reintenta mover/aplicar mientras aparece el widget
    obs = new MutationObserver(
        debounce(() => {
            if (!JDGM_MOVED) moveJudgeMe();
            if (!JDGM_TITLE_APPLIED) setReviewsTitle();
            updateProductRating();

            // Si ya movimos y aplicamos título, podemos dejar de observar
            if (JDGM_MOVED && JDGM_TITLE_APPLIED) {
                obs.disconnect();
            }
        }, 150)
    );
    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Eventos Judge.me
    window.addEventListener('jdgm:ready', debounce(() => {
        setReviewsTitle();
        updateProductRating();
    }, 100), { once: true });

    window.addEventListener('jdgm:refresh', debounce(() => {
        JDGM_TITLE_APPLIED = false; // permite re-aplicar si re-renderiza
        setReviewsTitle();
        updateProductRating();
    }, 120));

    // Tabs/acordeones que muestran reseñas
    document.addEventListener('click', function (e) {
        if (e.target.matches('[data-tab="reviews"], .tabs__link--reviews, [href="#reviews"]')) {
            setTimeout(() => {
                window.dispatchEvent(new Event('jdgm:refresh'));
            }, 80);
        }
    });
});
